import * as Yup from "yup";
import i18n from "../i18n";

export const addDescriptionOfWarehouseItemCardSchema = Yup.object({
  itemType: Yup.string().required(
    i18n.language === "en" ? "Item type is required." : "نوع العنصر مطلوب."
  ),
  quantity: Yup.number().required(
    i18n.language === "en" ? "Quantity is required." : "الكمية مطلوبة."
  ),
  supplyingExportingEntityForPermitHolder: Yup.string().required(
    i18n.language === "en"
      ? "Supplying/Exporting Entity for Permit Holder is required."
      : "الجهة الموردة/المصدرة لحامل التصريح مطلوبة."
  ),
});
